export const jobIndex = (nextIndex, count) => {
  if (count < 1) return -1;

  return (nextIndex + count) % count;
};

export const activateJob = (root, nextIndex, focus = false) => {
  const tabs = [...root.querySelectorAll("[data-job-tab]")];
  const panels = [...root.querySelectorAll("[data-job-panel]")];

  if (!tabs.length || !panels.length) return -1;

  const index = jobIndex(nextIndex, tabs.length);
  const selected = tabs[index];
  const job = selected.dataset.job;

  root.dataset.jobCurrent = job;

  tabs.forEach((tab, tabIndex) => {
    const active = tabIndex === index;

    tab.setAttribute("aria-selected", String(active));
    tab.tabIndex = active ? 0 : -1;

    if (active) {
      tab.dataset.current = "true";
    } else {
      delete tab.dataset.current;
    }
  });

  panels.forEach(panel => {
    panel.hidden = panel.dataset.job !== job;
  });

  if (focus) selected.focus();

  return index;
};

export const initJobs = (root = document) => {
  const groups = [...root.querySelectorAll("[data-job-tabs]")];
  const cleanups = groups.map(group => {
    const tabs = [...group.querySelectorAll("[data-job-tab]")];

    if (!tabs.length) return () => {};

    const selected = tabs.findIndex(tab => tab.getAttribute("aria-selected") === "true");
    let current = activateJob(group, selected >= 0 ? selected : 0);

    const click = event => {
      const tab = event.target.closest("[data-job-tab]");

      if (!tab || !group.contains(tab)) return;
      current = activateJob(group, tabs.indexOf(tab));
    };

    const keydown = event => {
      const tab = event.target.closest("[data-job-tab]");

      if (!tab || !group.contains(tab)) return;

      const commands = {
        ArrowLeft: current - 1,
        ArrowRight: current + 1,
        End: tabs.length - 1,
        Home: 0,
      };

      if (!(event.key in commands)) return;

      event.preventDefault();
      current = activateJob(group, commands[event.key], true);
    };

    group.addEventListener("click", click);
    group.addEventListener("keydown", keydown);

    return () => {
      group.removeEventListener("click", click);
      group.removeEventListener("keydown", keydown);
    };
  });

  return () => cleanups.forEach(cleanup => cleanup());
};

if (typeof document !== "undefined") {
  initJobs();
}
